<template>
<div class="iframe-resize-container" :style="{maxWidth}">
  <div class="iframe-content">
    <iframe ref="iframe" :src="attributes.value" frameborder="0" scrolling="no" ></iframe>
  </div>
</div>
</template>

<script>
/* globals iFrameResize */
import 'iframe-resizer/js/iframeResizer.min'

export default {
  props: ['attributes'],
  computed: {
    maxWidth () {
      const {maxwidth} = this.attributes
      return maxwidth || 'auto'
    }
  },
  mounted () {
    iFrameResize({}, this.$refs.iframe)
  }
}
</script>

<style lang="scss">
.iframe-resize-container {
  line-height: 0;

  .iframe-content {
    margin: 0 auto;

    iframe {
      width: 1px;
      min-width: 100%;

    }
  }
}
</style>
